import { render, staticRenderFns } from "./myFavorites.vue?vue&type=template&id=f5cfb6a8&scoped=true&"
import script from "./myFavorites.vue?vue&type=script&lang=js&"
export * from "./myFavorites.vue?vue&type=script&lang=js&"
import style0 from "./myFavorites.vue?vue&type=style&index=0&id=f5cfb6a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cfb6a8",
  null
  
)

export default component.exports